import axiosInstance from '../helpers/axiosConfig';
import { createAsyncThunk } from "@reduxjs/toolkit";


export const fetchSites = createAsyncThunk(
    'sites/fetchSites',
    async (token, { rejectWithValue }) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': token
            },
        };

        try {
            const res = await axiosInstance.get('sites', config)
            return res.data
        } catch (err) {
            console.error('Registration error:', err.response.data);
            return rejectWithValue(err.response.data)
        }
    }
)

export const fetchStagingStatus = createAsyncThunk(
    'sites/fetchStagingStatus',
    async (token, { rejectWithValue }) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': token
            },
        };

        try {
            const res = await axiosInstance.get('sites/staging-status', config)
            return res.data
        } catch (err) {
            return rejectWithValue(err.response?.data)
        }
    }
)
